import { render, staticRenderFns } from "./foodsearch.vue?vue&type=template&id=fa64d4ec&scoped=true"
import script from "./foodsearch.vue?vue&type=script&lang=js"
export * from "./foodsearch.vue?vue&type=script&lang=js"
import style0 from "./foodsearch.vue?vue&type=style&index=0&id=fa64d4ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa64d4ec",
  null
  
)

export default component.exports